// hooks/useDocumentTitle.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { titleService } from './titleService';

// 基础Hook - 只根据路径设置标题
export const useDocumentTitle = (title?: string): void => {
  const location = useLocation();

  useEffect(() => {
    const finalTitle = title || titleService.getTitle(location.pathname);
    document.title = finalTitle;
    
    // 可选：在开发环境下打印标题变化
    if (process.env.NODE_ENV === 'development') {
      console.log(`Title updated to: "${finalTitle}" for path: ${location.pathname}`);
    }
  }, [location.pathname, title]);
};

// 获取页面信息的 Hook
export const usePageInfo = () => {
  const location = useLocation();
  
  return {
    pageInfo: titleService.getPageByUrl(location.pathname),
    allPages: titleService.getAllPages()
  };
};